module.exports = __webpack_public_path__ + "static/media/19.13722a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/19.png
// module id = 978
// module chunks = 0